import { EntityActionFactory, EntityOp } from '@ngrx/data';

import { Especie } from './especies.model';

const entityActionFactory = new EntityActionFactory();

export const entityEspecieLoadRequest = entityActionFactory.create<Especie>(
  'Especie',
  EntityOp.QUERY_ALL
);
